
<template>
  <div style="text-align: left">
    <el-row>
      <el-col :span="6">
        <!--<el-button type="primary" :icon="icon" size="mini" style="background-color: #3B6064 ; border: 0" @click="collapseMenu"></el-button>-->
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      stripe
      height="75vh"
      border
      style="width: 100%">
      <el-table-column
        label="序号"
        type="index"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="dataType"
        label="数据类型"
        width="180">
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        width="180">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="600">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleClick(scope.row)">查看</el-button>
          <el-button type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="pageData.page"
      :page-sizes="pageData.sizes"
      :page-size="pageData.limit"
      layout="sizes, prev, pager, next"
      :total="pageData.count"
      style="align-self: left"
      @size-change="sizeChange"
      @current-change="getHandleDataTypes">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'HandleDataType',
  data() {
    return {
      pageData: {
        sizes: [10, 20, 30],
        count: 0,
        data: [],
        code: 0,
        msg: '',
        page: 1,
        limit: 10
      },
      tableData: []
    }
  },
  created() {
    this.getHandleDataTypes()
  },
  methods: {
    handleClick(row) {
    },
    getHandleDataTypes() {
    },
    sizeChange(size) {
      this.pageData.limit = size
      this.getHandleDataTypes()
    }
  }

}
</script>

<style scoped>

</style>
